module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"50","viewBox":"0 0 50 50"},"content":"<path fill=\"#5690FF\" class='channel-icon-logo' fill-rule=\"evenodd\" d=\"M20.39 48V28.403H13v-8.63h7.39v-6.365C20.39 6.022 24.863 2 31.397 2c3.13 0 5.82.235 6.603.34v7.72l-4.532.001c-3.553 0-4.24 1.703-4.24 4.202v5.51h8.474l-1.104 8.63h-7.37V48H20.39z\"/>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/channel/facebook.svg
// module id = 1301
// module chunks = 0